import { Illustration, type IllustrationType } from "@clipboard-health/ui-components";
import { Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Box, CardContent, Stack } from "@mui/material";
import {
  ShiftBottomSheetInnerCard,
  type ShiftBottomSheetInnerCardIntent,
} from "@src/appV2/redesign/Shift/BottomSheet/InnerCard";
import { type ReactNode } from "react";

interface VisitBottomSheetInnerCardProps {
  pill?: ReactNode;
  illustrationType: IllustrationType;
  title: ReactNode;
  description?: ReactNode;
  footer?: ReactNode;
  intent?: ShiftBottomSheetInnerCardIntent;
}

export function VisitBottomSheetInnerCard(props: VisitBottomSheetInnerCardProps) {
  const { intent = "neutral", pill, illustrationType, title, description, footer } = props;
  return (
    <ShiftBottomSheetInnerCard intent={intent} sx={{ minHeight: "auto" }}>
      <CardContent
        sx={{
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          px: 6,
        }}
      >
        {isDefined(pill) && <Box sx={{ width: "100%", alignSelf: "flex-start" }}>{pill}</Box>}

        <Stack
          alignItems="center"
          justifyContent="center"
          spacing={5}
          sx={{
            textAlign: "center",
            textWrap: "balance",
            width: "100%",
            flexGrow: 1,
            mb: isDefined(footer) ? "auto" : undefined,
          }}
        >
          <Illustration type={illustrationType} />

          <Text semibold variant="h5">
            {title}
          </Text>

          {isDefined(description) && (
            <Text color={(theme) => theme.palette.text.secondary} variant="body2">
              {description}
            </Text>
          )}
        </Stack>

        {isDefined(footer) && <Box sx={{ width: "100%", mt: 5 }}>{footer}</Box>}
      </CardContent>
    </ShiftBottomSheetInnerCard>
  );
}
